import { useEffect } from "react";
import { useRouter } from "next/router";
import { Flex, useColorModeValue } from "@chakra-ui/react";
import { useAppSelector } from "@/lib/hooks";
import { Loader } from "@/utils/Loader";
import { SignInParticles } from "../Particles/SignInParticles";
import { VairitasCopyrightText } from "./VairitasCopyrightText";

type Props = {
  children: React.ReactNode;
};

export default function SignInLayout({ children }: Props) {
  const router = useRouter();
  const accessToken = useAppSelector((state) => state.user.accessToken);
  const { clientType } = useAppSelector((state) => state.app);

  const borderColor = useColorModeValue("gray.200", "gray.700");
  const bg = useColorModeValue("#ffffff", "#1A202C ");
  let w: string | string[] = ["100%", "lg"];

  useEffect(() => {
    if (accessToken !== "") {
      router.push("/dashboard");
    }
  }, [accessToken, router]);

  if (accessToken !== "") {
    return (
      <Flex
        justifyContent="center"
        alignItems="center"
        minH={"100dvh"}
        maxW={"100%"}
        minW={"100%"}
        h={"100vh"}
      >
        <Loader w="250px" />
      </Flex>
    );
  }
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      minH={"100dvh"}
      maxW={"100%"}
    >
      <Flex
        mt={5}
        userSelect={"none"}
        bg={bg}
        w="100%"
        justifyContent={"center"}
        alignItems={"center"}
      >
        <SignInParticles />

        <Flex
          mt={"-100px"}
          zIndex={1}
          borderStyle={"solid"}
          bg={bg}
          borderColor={borderColor}
          boxShadow={"md"}
          p={"10"}
          w={w}
          h={"fit-content"}
          direction={"column"}
          mx={5}
        >
          {children}
        </Flex>
      </Flex>

      {clientType === "VAIRITAS" && (
        <Flex
          justifyContent={"center"}
          borderTopWidth={1}
          position={"absolute"}
          w="100%"
          py={2}
          bg="white"
          bottom={0}
        >
          <VairitasCopyrightText
            fontSize={"sm"}
            color="gray.900"
            textAlign={"center"}
          />
        </Flex>
      )}
    </Flex>
  );
}
